import { TFunction } from 'i18next';

export const getStatusOptions = (t: TFunction) => ({
  NEW: t('consignment.status.new', 'New'),
  AC: t('consignment.status.accepted', 'Accepted'),
  IP: t('consignment.status.inProgress', 'In Progress'),
  CO: t('consignment.status.completed', 'Completed'),
  CA: t('consignment.status.cancelled', 'Cancelled'),
  OH: t('consignment.status.onHold', 'On Hold')
});

export const getCancellationReasonOptions = (t: TFunction) => ({
  A: t('consignment.cancellationReason.accident', 'Accident'),
  L: t('consignment.cancellationReason.lateDelivery', 'Late Delivery'),
  S: t('consignment.cancellationReason.securityIssue', 'Security Issue'),
  E: t('consignment.cancellationReason.error', 'Error'),
  O: t('consignment.cancellationReason.other', 'Other')
});
